module.exports = "<div> <group title=Dialog> <group-item title=1个按钮 right-desc=点击出弹窗 @click=triggerDialog1></group-item> <group-item title=2个按钮 right-desc=点击出弹窗 @click=triggerDialog2></group-item> <group-item title=2个以上按钮 right-desc=点击出弹窗 @click=triggerDialog3></group-item> </group> <dialog :show=dialog.show :head=dialog.head :content=dialog.content :buttons=dialog.buttons></dialog> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/Dialog.vue
 ** module id = 183
 ** module chunks = 0
 **/